var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScatterChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13733_6060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 179H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 150H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 161,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 147,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 116,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 168,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 163,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 94,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 168,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 115,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 132,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 125,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.436,
    cy: 122.451,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 131,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 116,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 117,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 151,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 119,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 107,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 113,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 107,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 140,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 110,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 106.602,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6392,
    cy: 97,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.639,
    cy: 105,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 101.917,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 98,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 114,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 154,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 143,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 141,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 74,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 83,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 83,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 81,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 95,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 127,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 103,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 75,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 146,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 168,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 147,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 141,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 167,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 158,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 168,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 158,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 163,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 153,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 90,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 63,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 168,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 158,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 115,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 149,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 151,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 138,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 124,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.436,
    cy: 122.451,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 120,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 125,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 108,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 141,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 151,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 45,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.872,
    cy: 112.451,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 100,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 113,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 103,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 107,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 117,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 153,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 123,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 100,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 96.6016,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6392,
    cy: 97,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.6392,
    cy: 87,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 149,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 159,
    r: 4,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 101.917,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 91.917,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 106,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.8569,
    cy: 88,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 114,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 107,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 154,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 143,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 141,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 131,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 82,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 57,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.562,
    cy: 91.5617,
    r: 4,
    transform: "rotate(8.7463 113.562 91.5617)",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 65,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 73,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 167,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 55,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 49,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 90,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 47,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 122,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 100,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 98,
    r: 4,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 75,
    r: 4,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 66,
    r: 4,
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13733_6060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterChartPreview);
export default __webpack_public_path__ + "static/media/scatterChartPreview.2f537892fc203a558aa8ee82df1053d1.svg";
export { ForwardRef as ReactComponent };